<div mat-dialog-title style="margin:0px;">
    About SIS K-12
    <div style="font-size:14px; font-weight:normal; color:black;">© {{currentDate.getFullYear()}} Copyright Tyler Technologies, Inc. All rights reserved.</div>
</div>

<mat-dialog-content>

    <table *ngIf="aboutTyler">
        <tr style="height:40; border-bottom: thin solid lightgray; border-top: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                360 Application Version
            </td>
            <td>
                {{aboutTyler.ApplicationVersion}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Classic Application Version
            </td>
            <td>
                {{legacyVersion}}
            </td>
        </tr>
        <tr *ngIf="!loginSettings.V10" style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Hot Fix Version
            </td>
            <td>
                {{aboutTyler.HotFixVersion}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Database
            </td>
            <td>
                {{aboutTyler.Database}}
            </td>
        </tr>
        <tr *ngIf="loginSettings.V10" style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Reports Version
            </td>
            <td>
                {{aboutTyler.ReportsVersion}}
            </td>
        </tr>
        <tr *ngIf="loginSettings.V10" style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Report Server
            </td>
            <td>
                {{aboutTyler.ReportServer}}
            </td>
        </tr>
        <tr *ngIf="loginSettings.V10" style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                TCM Integration
            </td>
            <td>
                {{aboutTyler.TCMIntegration}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                SPED Integration
            </td>
            <td>
                {{aboutTyler.SpEdIntegration}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Server Name
            </td>
            <td>
                {{aboutTyler.ServerName}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Operating System
            </td>
            <td>
                {{aboutTyler.OperatingSystem}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                .Net Version
            </td>
            <td>
                {{aboutTyler.DotNetVersion}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Database Version
            </td>
            <td>
                {{aboutTyler.DatabaseVersion}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Client Name (IP)
            </td>
            <td>
                {{aboutTyler.ClientName}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Platform / Browser
            </td>
            <td>
                {{aboutTyler.PlatformBrowser}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Browser Language
            </td>
            <td>
                {{aboutTyler.BrowserLanguage}}
            </td>
        </tr>
        <tr style="height:40; border-bottom: thin solid lightgray;">
            <td style="width:200px; padding-left:10px;">
                Browser Compatible
            </td>
            <td>
                {{aboutTyler.BrowserCompatible}}
            </td>
        </tr>
    </table>

</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button id="aboutCloseButton" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>